import { useEffect } from 'react';
import { findNextTabbable, getTabbableElements } from '../../../helpers/tabbableHelper';

const MODAL_WRAP_SELECTOR = '.ant-modal-wrap';
const MODAL_CONTENT_SELECTOR = '.ant-modal-content';

/** office.js in Outlook on the web tabs across the whole page, past rc-dialog's sentinels, so the dialog's ends wrap here. */
export const keepTabInsideModal = (event: KeyboardEvent) => {
  if (event.key !== 'Tab' || event.defaultPrevented) return;
  const from = event.target;
  if (!(from instanceof HTMLElement)) return;
  const content = from
    .closest(MODAL_WRAP_SELECTOR)
    ?.querySelector<HTMLElement>(MODAL_CONTENT_SELECTOR);
  if (!content) return;

  const tabbables = getTabbableElements(content);
  const next = findNextTabbable(tabbables, from, event.shiftKey);
  if (next && tabbables.includes(from)) return;

  event.preventDefault();
  event.stopPropagation();
  const wrappedTo = event.shiftKey ? tabbables[tabbables.length - 1] : tabbables[0];
  (next ?? wrappedTo)?.focus();
};

/** Listens on the document so controls inside the dialog see Tab first, and office.js's window listener never does. */
export const useKeepTabInsideModal = (open: boolean) => {
  useEffect(() => {
    if (!open) return undefined;
    // A listener per dialog, so closing a nested one leaves the outer one trapped.
    const listener = (event: KeyboardEvent) => keepTabInsideModal(event);
    document.addEventListener('keydown', listener);
    return () => document.removeEventListener('keydown', listener);
  }, [open]);
};
